import React from 'react';

import Banner from './components/Banner.js';
import IconSet from './components/IconSet.js';
import Feature from './components/Feature.js';
import Features from './components/Features.js';
import Footer from './components/Footer.js';
import Home from './components/Home.js';
import Ide from './components/Ide.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

class App extends React.Component {

    componentDidMount() {
        AOS.init({
            duration: 1000
        })
    }

    render() {
        const linkDevOps = 'https://www.credly.com/badges/1e61bf3f-3297-46de-afc0-0b97021b70f0';
        const linkWellArch = 'https://www.credly.com/badges/5dd9eaea-4959-4c1e-982d-9319d9d6575d';

        return (
            <div className='App'>

                <Home
                    id='home'
                    title="I'm Graeme, a full stack software engineer."
                    content='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                    hrefPrimary='#discover'
                    hrefSecondary='https://github.com/GraemeRJBrown'
                    />

                <IconSet id='core-skills' />

                <Banner
                    id='discover'
                    title='Design, Development &amp; Software Engineering'
                    text='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' />

                <div className='vr' style={{ 'height': '4em' }}></div>

                <Feature
                    id='feature-devops'
                    title='DevOps.'
                    titleColor='primary'
                    lead='Deliver Solutions with Velocity'
                    content='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
                    display={
                        <Ide
                            title='graemerjbrown.github.io'
                            filename='stack.yml'
                            code={this.getCloudFormation()}
                        />
                    }
                    href={ linkDevOps } />

                <div className='vr' style={{ 'height': '4em' }}></div>

                <Feature
                    id='feature-well-architected'
                    title='Well-Architected.'
                    titleColor='primary'
                    lead='High-performing &amp; Resilient Workloads'
                    content='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
                    display={
                        <Ide
                            title='graemerjbrown.github.io'
                            filename='Feature.js'
                            code={this.getJavaScriptSnippet()}
                        />
                    }
                    layoutTextLeft
                    href={ linkWellArch } />

                <Features
                    id='project' />

                <Footer />

            </div>
        );
    }

    /**
     * Returns CloudFormation snippet.
     * @returns {JSX} YAML.
     */
    getCloudFormation() {

        const darkBlue = '#4682b4';
        const lightBlue = '#66d9ef';

        return (
            <p>
                <span style={{ 'color': darkBlue }}>AWSTemplateFormatVersion:</span>&nbsp;<span style={{ 'color': lightBlue }}>'2010-09-09'</span>

                <br/>
                <span style={{ 'color': darkBlue }}>Parameters:</span>
                <br/>
                &nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>ServiceToken:</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>Description:</span>&nbsp;<span style={{ 'color': lightBlue }}>'Service token'</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>Type:</span>&nbsp;<span style={{ 'color': lightBlue }}>'String'</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>MinLength:</span>&nbsp;<span style={{ 'color': lightBlue }}>'1'</span>

                <br/>
                <span style={{ 'color': darkBlue }}>Resources:</span>
                <br/>
                &nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>CustomResource:</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>Type: </span><span style={{ 'color': lightBlue }}>AWS::CloudFormation::CustomResource</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>Properties:</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>ServiceToken: </span><span style={{ 'color': lightBlue }}>!Ref ServiceToken</span>

                <br/>
                <span style={{ 'color': darkBlue }}>Outputs:</span>
                <br/>
                &nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>ResourceARN:</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>Description:</span>&nbsp;<span style={{ 'color': lightBlue }}>'Output ARN'</span>
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>Value: !GetAtt</span>&nbsp;<span style={{ 'color': lightBlue }}>CustomResource.Arn</span>
            </p>
        );
    }

    /**
     * Returns JavaScript snippet.
     * @returns {JSX} Snippet.
     */
    getJavaScriptSnippet() {

        const darkBlue = '#4682b4';
        const lightBlue = '#66d9ef';
        const white = 'white';
        const orange = 'orange';

        return (
            <p>
                <span style={{ 'color': darkBlue }}>import</span>
                &nbsp;
                <span style={{ 'color': lightBlue }}>React</span>
                <span style={{ 'color': white }}>,&nbsp;{'{'}</span>
                &nbsp;
                <span style={{ 'color': lightBlue }}>Component</span>
                &nbsp;
                <span style={{ 'color': white }}>{'}'}</span>
                &nbsp;
                <span style={{ 'color': darkBlue }}>from</span>
                &nbsp;
                <span style={{ 'color': orange }}>'react'</span>
                <span style={{ 'color': white }}>;</span>

                <br/>

                <span style={{ 'color': darkBlue }}>class</span>
                &nbsp;
                <span style={{ 'color': lightBlue }}>Feature</span>
                &nbsp;
                <span style={{ 'color': darkBlue }}>extends</span>
                &nbsp;
                <span style={{ 'color': lightBlue }}>Component</span>
                &nbsp;
                <span style={{ 'color': white }}>{'{'}</span>

                <br/>

                &nbsp;&nbsp;
                <span style={{ 'color': lightBlue }}>render</span>
                <span style={{ 'color': white }}>()&nbsp;{'{'}</span>

                <br/>

                &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>const</span>
                &nbsp;
                <span style={{ 'color': lightBlue }}>image</span>
                &nbsp;
                <span style={{ 'color': white }}>=</span>
                &nbsp;
                <span style={{ 'color': darkBlue }}>this</span>
                <span style={{ 'color': white }}>.</span>
                <span style={{ 'color': lightBlue }}>getImage</span>
                <span style={{ 'color': white }}>();</span>

                <br/>

                &nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{ 'color': darkBlue }}>const</span>
                &nbsp;
                <span style={{ 'color': lightBlue }}>content</span>
                &nbsp;
                <span style={{ 'color': white }}>=</span>
                &nbsp;
                <span style={{ 'color': darkBlue }}>this</span>
                <span style={{ 'color': white }}>.</span>
                <span style={{ 'color': lightBlue }}>getContent</span>
                <span style={{ 'color': white }}>();</span>
            </p>
        );
    }

}

export default App;
